export default __webpack_public_path__ + "static/media/home.e11cc423.svg";